import { useTheme } from '@mui/styles';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    indicatorsContainer: {
      overflow: 'auto',
      marginTop: theme.spacing(0.2),
      display: 'flex',
      flexDirection: 'column',
    },
    configureButton: {
      marginRight: 'auto',
      marginLeft: 'auto',
      width: 'fit-content',
      fontSize: '0.6875rem',
    },
    noActiveIndicatorsMessage: {
      margin: theme.spacing(1, 'auto'),
    },
  };
};
